export const MODAL_TYPES = {
  ASSIGN_ADMIN: "ASSIGN_ADMIN",
  ASSIGN_CONSULTOR: "ASSIGN_CONSULTOR",
  UPDATE_LICENSES: "UPDATE_LICENSES",
  UPDATE_MEETINGS: "UPDATE_MEETINGS",
};
